import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormInputControlled from "components/FormInputControlled/FormInputControlled";
import { Form } from "components/Form/Form";
import { getCardHolderEditValidationSchema } from "modules/CardHolders/validations";
import { MODULES } from "shared/config";

const CardHolderEditModalForm = ({
  action,
  handleOnSubmit,
  loading,
  list,
  item,
  apiErrors,
  moduleName,
}) => {
  const validationSchema = getCardHolderEditValidationSchema(moduleName);

  const form = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    defaultValues: {
      responsible_person_email: item.responsible_person_email,
      supervisor_email: item.supervisor_email,
      card_holder_name: item.card_holder_name,
    },
  });

  const {
    // eslint-disable-next-line no-unused-vars
    formState: { errors, isValid, isDirty, dirtyFields },
    reset,
  } = form;

  const responsiblePersonsEmailApiErrors =
    apiErrors?.response?.data?.errors?.responsible_person_email;
  const supervisorApiErrors =
    apiErrors?.response?.data?.errors?.supervisor_email;
  const cardHolderNameApiErrors =
    apiErrors?.response?.data?.errors?.card_holder_name;

  return (
    <Form
      form={form}
      id={list + "-" + action + "-modal-form"}
      onSubmit={(data) => handleOnSubmit(action, item, data)}
      onReset={reset}
    >
      <FormInputControlled
        label="Responsible Person's E-mail"
        name="responsible_person_email"
        loading={loading}
        placeholder="Enter Responsible Person's E-mail"
        popoverText={
          <>
            Only DSV emails (with <b>dsv.com</b>) are allowed.
          </>
        }
        apiErrors={responsiblePersonsEmailApiErrors}
      />
      {moduleName === MODULES.CREDIT_CARDS && (
        <FormInputControlled
          label="Supervisor's E-mail"
          name="supervisor_email"
          loading={loading}
          placeholder="Enter Supervisor's E-mail"
          popoverText={
            <>
              Only DSV emails (with <b>dsv.com</b>) are allowed.
            </>
          }
          apiErrors={supervisorApiErrors}
        />
      )}
      {moduleName === MODULES.CORPORATE_CARDS && (
        <FormInputControlled
          label="Card holder name"
          name="card_holder_name"
          loading={loading}
          placeholder="Enter card holder's name"
          apiErrors={cardHolderNameApiErrors}
          onChangeMiddleware={(event) => {
            event.target.value = event.target.value.toUpperCase();
            return event;
          }}
        />
      )}
    </Form>
  );
};

export default CardHolderEditModalForm;
